export default __webpack_public_path__ + "static/media/promo_05.3cadb322.jpg";